import { arrayIncludes } from "ts-extras";
import type { Bounds } from "../../common/geo/types";
import {
    EU_REGION,
    supportedCountries,
} from "../../config/countries/supportedCountries";
import { useRegionForCurrentLocale } from "../../config/countries/useRegionForCurrentLocale";
import { useMaps } from "../../useMaps";
import type { GeoCoordinates } from "../locationPopup/useGeoLocator";

type UseInitialMapCameraSettingsReturn = {
    initialBounds: Bounds | undefined;
    initialZoom: number | undefined;
    initialCenter: GeoCoordinates | undefined;
};

export function useInitialMapCameraSettings(): UseInitialMapCameraSettingsReturn {
    const { mapsProps } = useMaps();

    const regionForCurrentLocale = useRegionForCurrentLocale();

    let initialBounds: Bounds | undefined;

    if (
        mapsProps.shownLayers !== undefined &&
        arrayIncludes(mapsProps.shownLayers, "pollen")
    ) {
        initialBounds = EU_REGION.bounds;
    } else if (mapsProps.camera?.country) {
        initialBounds = supportedCountries[mapsProps.camera.country].bounds;
    } else if (mapsProps.camera?.bounds) {
        initialBounds = mapsProps.camera.bounds;
    } else if (mapsProps.camera?.center) {
        initialBounds = undefined;
    } else {
        initialBounds = regionForCurrentLocale.bounds;
    }

    let initialCenter;

    if (mapsProps.camera?.center === undefined) {
        initialCenter = undefined;
    } else {
        initialCenter = {
            lng: mapsProps.camera.center[0],
            lat: mapsProps.camera.center[1],
        };
    }

    return {
        initialBounds,
        initialCenter,
        initialZoom: mapsProps.camera?.zoom,
    };
}
